import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2076Status: 'idle',
    startProcess2076Error: undefined as any,
    loadUserParamsProcess2076Status: 'idle',
    loadUserParamsProcess2076Error: undefined as any,

    process2076List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2076 = createAsyncThunk('process2076Slice/startProcess2076', async ({ process2076 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2076/`,
        prepareData(process2076),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2076Status } = getState().process2076Slice
        return startProcess2076Status !== 'pending'
    }
})

export const loadUserParamsProcess2076 = createAsyncThunk('process2076Slice/loadUserParamsProcess2076', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2076/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2076Status } = getState().process2076Slice
        return loadUserParamsProcess2076Status !== 'pending'
    }
})

const Process2076Slice = createSlice({
    name: 'process2076Slice',
    initialState,
    reducers: {
        resetstartProcess2076: (state) => {
            state.job = undefined
            state.startProcess2076Error = undefined
        },
        resetstartProcess2076Error: (state) => {
            state.startProcess2076Error = undefined
        },
        resetloadUserParamsProcess2076: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2076Error = undefined
        },
        resetloadUserParamsProcess2076Error: (state) => {
            state.loadUserParamsProcess2076Error = undefined
        },
        removeFromProcess2076ListById: (state, action) => {
            state.process2076List = state.process2076List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2076ListByIds: (state, action) => {
            state.process2076List = state.process2076List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2076List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2076Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2076List = []
            state.startProcess2076Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2076.pending, (state) => {
            state.startProcess2076Status = 'pending'
            state.startProcess2076Error = undefined
        })
        builder.addCase(startProcess2076.fulfilled, (state, action) => {
            state.startProcess2076Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2076.rejected, (state, action) => {
            state.startProcess2076Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2076Error = action.error.message
            } else {
                state.startProcess2076Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2076.pending, (state) => {
            state.loadUserParamsProcess2076Status = 'pending'
            state.loadUserParamsProcess2076Error = undefined
        })
        builder.addCase(loadUserParamsProcess2076.fulfilled, (state, action) => {
            state.loadUserParamsProcess2076Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2076.rejected, (state, action) => {
            state.loadUserParamsProcess2076Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2076Error = action.error.message
            } else {
                state.loadUserParamsProcess2076Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2076,
    resetstartProcess2076Error,
    resetloadUserParamsProcess2076,
    resetloadUserParamsProcess2076Error,
    removeFromProcess2076ListById,
    removeFromProcess2076ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2076Slice.actions
export default Process2076Slice.reducer
